import {InjectableRxStompConfig} from '@stomp/ng2-stompjs';

export const adaRxStompConfig: InjectableRxStompConfig = {
  // socket url depends on the environment. see setBrokerUrl
  brokerURL: '',
  heartbeatIncoming: 0,
  heartbeatOutgoing: 20000,
  reconnectDelay: 500,
  // debug: (msg: string): void => {
  //    console.log(new Date(), msg);
  // },
};

/** needs to be set after environment is fetched from server */
export function setBrokerUrl(url: string) {
  adaRxStompConfig.brokerURL = url;
}